import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

const StatusSelect = ({ value, onChange, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);
    const dropdownRef = useRef(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    const statusLabels = {
        PENDING: 'Pendente',
        RESOLVED: 'Resolvido',
        CANCELED: 'Cancelado'
    };

    const statusColors = {
        PENDING: '#FFE0B2',
        RESOLVED: '#C8E6C9',
        CANCELED: '#FFCDD2'
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target) &&
                dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        const updatePosition = () => {
            if (isOpen && selectRef.current) {
                const rect = selectRef.current.getBoundingClientRect();
                setDropdownPosition({
                    top: rect.bottom + 2,
                    left: rect.left
                });
            }
        };

        if (isOpen) {
            updatePosition();
            window.addEventListener('scroll', updatePosition, true);
            window.addEventListener('resize', updatePosition);
        }

        return () => {
            window.removeEventListener('scroll', updatePosition, true);
            window.removeEventListener('resize', updatePosition);
        };
    }, [isOpen]);

    const handleSelect = (status) => {
        onChange(status);
        setIsOpen(false);
    };

    const renderDropdown = () => {
        if (!isOpen) return null;

        return createPortal(
            <div 
                ref={dropdownRef}
                style={{
                    position: 'fixed',
                    top: dropdownPosition.top + 'px',
                    left: dropdownPosition.left + 'px',
                    width: '130px',
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    zIndex: 10001,
                    overflow: 'hidden'
                }}>
                {Object.entries(statusLabels).map(([status, label]) => (
                    <div
                        key={status}
                        onClick={() => handleSelect(status)}
                        style={{
                            padding: '8px 12px',
                            backgroundColor: statusColors[status],
                            color: '#333',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            transition: 'opacity 0.2s',
                            opacity: status === value ? 0.7 : 1
                        }}
                        onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                        onMouseLeave={(e) => e.target.style.opacity = status === value ? '0.7' : '1'}
                    >
                        {label}
                    </div>
                ))}
            </div>,
            document.body
        );
    };

    return (
        <div ref={selectRef} style={{ position: 'relative', display: 'inline-block' }}>
            <div
                onClick={() => !disabled && setIsOpen(!isOpen)}
                style={{
                    padding: '6px 24px 6px 12px',
                    borderRadius: '4px',
                    backgroundColor: statusColors[value],
                    color: '#333',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    border: '1px solid #ccc',
                    cursor: disabled ? 'default' : 'pointer',
                    minWidth: '120px',
                    position: 'relative',
                    userSelect: 'none'
                }}
            >
                {statusLabels[value]}
                <span style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '10px'
                }}>
                    {isOpen ? '▲' : '▼'}
                </span>
            </div>

            {renderDropdown()}
        </div>
    );
};

export default StatusSelect;
